import script from "./MapElemInfoLandAiDetections.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoLandAiDetections.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoLandAiDetections.vue?vue&type=style&index=0&id=2975335f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2975335f"]])

export default __exports__